import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import ShortUrl from "./fulfillment/short-url";
import Error404 from "./error/error404";
import XeroPayment from "./fulfillment/xero/xero-payment";
import EftSignup from "./fulfillment/eft/eft-payment";
import InvisibleRecaptcha from "./components/invisible-recaptcha/invisible-recaptcha";
import ConfirmSmartCode from "./fulfillment/components/confirm-smart-code";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={'/r/:shortCode'}>
          <ShortUrl/>
        </Route>
        <Route path={'/smart/:smartCode'}>
          <InvisibleRecaptcha Child={ConfirmSmartCode} />
        </Route>
        <Route path={'/xero'}>
          <XeroPayment />
        </Route>
        <Route path={'/pay/:shortCode/eft'}>
          <EftSignup/>
        </Route>
        <Route path='/'>
          <Error404 />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
